var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.861,
    height: 94.009,
    viewBox: "0 0 96.861 94.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45091",
    "data-name": "Group 45091",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76033",
    "data-name": "Path 76033",
    d: "M103.755,74.782,33.213,84.318A1.878,1.878,0,0,1,31.1,82.709L21.565,12.166a1.878,1.878,0,0,1,1.609-2.113L93.716.517a1.879,1.879,0,0,1,2.113,1.611l9.536,70.542a1.877,1.877,0,0,1-1.609,2.113",
    transform: "translate(-21.548 -0.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76033_-_Outline",
    "data-name": "Path 76033 - Outline",
    d: "M32.959,85.335a2.886,2.886,0,0,1-2.85-2.493L20.574,12.3A2.878,2.878,0,0,1,23.04,9.063L93.582-.474A2.877,2.877,0,0,1,96.82,1.994l9.536,70.542a2.877,2.877,0,0,1-2.467,3.238L33.347,85.309A2.912,2.912,0,0,1,32.959,85.335ZM93.969,1.5a.9.9,0,0,0-.12.008L23.308,11.045a.878.878,0,0,0-.752.988l9.536,70.542a.879.879,0,0,0,.868.76.9.9,0,0,0,.12-.008l70.542-9.536a.877.877,0,0,0,.752-.987L94.838,2.261A.88.88,0,0,0,93.969,1.5Z",
    transform: "translate(-21.548 -0.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76034",
    "data-name": "Path 76034",
    d: "M32.959,85.085a2.635,2.635,0,0,1-2.6-2.276L20.821,12.267A2.628,2.628,0,0,1,23.074,9.31L93.616-.227a2.627,2.627,0,0,1,2.956,2.254l9.536,70.542a2.627,2.627,0,0,1-2.252,2.956L33.313,85.061A2.658,2.658,0,0,1,32.959,85.085ZM93.969,1.25a1.151,1.151,0,0,0-.153.01L23.274,10.8a1.129,1.129,0,0,0-.966,1.269l9.536,70.542a1.13,1.13,0,0,0,1.116.977,1.153,1.153,0,0,0,.153-.01l70.542-9.536a1.127,1.127,0,0,0,.966-1.268L95.086,2.228A1.131,1.131,0,0,0,93.969,1.25Z",
    transform: "translate(-21.548 -0.5)",
    fill: "#37509e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76035",
    "data-name": "Path 76035",
    d: "M101.054,72.566,34.093,81.617a1.878,1.878,0,0,1-2.113-1.609L22.928,13.046a1.88,1.88,0,0,1,1.611-2.113L91.5,1.882a1.879,1.879,0,0,1,2.113,1.611l9.051,66.961a1.877,1.877,0,0,1-1.609,2.113",
    transform: "translate(-20.88 0.169)",
    fill: "#aec9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76036",
    "data-name": "Path 76036",
    d: "M104.753,88.581,33.731,83.792a1.878,1.878,0,0,1-1.748-2l4.789-71.022a1.878,1.878,0,0,1,2-1.748L109.8,13.81a1.879,1.879,0,0,1,1.748,2l-4.789,71.022a1.878,1.878,0,0,1-2,1.748",
    transform: "translate(-16.437 3.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76036_-_Outline",
    "data-name": "Path 76036 - Outline",
    d: "M104.882,89.335c-.059,0-.12,0-.179-.006L33.681,84.541a2.628,2.628,0,0,1-2.446-2.8l4.789-71.022a2.634,2.634,0,0,1,2.619-2.452c.059,0,.12,0,.179.006l71.023,4.789a2.632,2.632,0,0,1,2.446,2.8L107.5,86.884A2.635,2.635,0,0,1,104.882,89.335ZM38.643,9.767A1.13,1.13,0,0,0,37.52,10.82L32.732,81.842a1.128,1.128,0,0,0,1.05,1.2L104.8,87.833a1.132,1.132,0,0,0,1.2-1.05l4.789-71.022a1.13,1.13,0,0,0-1.05-1.2L38.721,9.77Z",
    transform: "translate(-16.437 3.673)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76037",
    "data-name": "Path 76037",
    d: "M104.882,89.335c-.059,0-.12,0-.179-.006L33.681,84.541a2.628,2.628,0,0,1-2.446-2.8l4.789-71.022a2.634,2.634,0,0,1,2.619-2.452c.059,0,.12,0,.179.006l71.023,4.789a2.632,2.632,0,0,1,2.446,2.8L107.5,86.884A2.635,2.635,0,0,1,104.882,89.335ZM38.643,9.767A1.13,1.13,0,0,0,37.52,10.82L32.732,81.842a1.128,1.128,0,0,0,1.05,1.2L104.8,87.833a1.132,1.132,0,0,0,1.2-1.05l4.789-71.022a1.13,1.13,0,0,0-1.05-1.2L38.721,9.77Z",
    transform: "translate(-16.437 3.673)",
    fill: "#37509e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76038",
    "data-name": "Path 76038",
    d: "M96.854,70.115l-57.48-3.875a1.88,1.88,0,0,1-1.748-2l3.3-48.968a1.878,1.878,0,0,1,2-1.748l57.48,3.875a1.88,1.88,0,0,1,1.748,2l-3.3,48.968a1.878,1.878,0,0,1-2,1.748",
    transform: "translate(-13.672 5.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76038_-_Outline",
    "data-name": "Path 76038 - Outline",
    d: "M96.983,71.119c-.065,0-.131,0-.2-.007l-57.48-3.875a2.884,2.884,0,0,1-2.678-3.065L39.93,15.2a2.886,2.886,0,0,1,2.87-2.685c.065,0,.131,0,.2.007l57.48,3.875a2.884,2.884,0,0,1,2.678,3.065l-3.3,48.969A2.886,2.886,0,0,1,96.983,71.119ZM42.8,14.518a.88.88,0,0,0-.875.82l-3.3,48.968a.881.881,0,0,0,.818.936l57.48,3.875a.879.879,0,0,0,.936-.817l3.3-48.968a.881.881,0,0,0-.818-.936L42.862,14.52Z",
    transform: "translate(-13.672 5.878)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76039",
    "data-name": "Path 76039",
    d: "M96.983,70.869c-.059,0-.12,0-.179-.006l-57.48-3.875a2.634,2.634,0,0,1-2.446-2.8l3.3-48.969A2.635,2.635,0,0,1,42.8,12.768c.059,0,.12,0,.179.006l57.48,3.875a2.634,2.634,0,0,1,2.446,2.8L99.6,68.417A2.635,2.635,0,0,1,96.983,70.869ZM42.8,14.268a1.131,1.131,0,0,0-1.124,1.053l-3.3,48.968a1.131,1.131,0,0,0,1.05,1.2L96.9,69.366a1.132,1.132,0,0,0,1.2-1.05l3.3-48.968a1.131,1.131,0,0,0-1.05-1.2l-57.48-3.875Z",
    transform: "translate(-13.672 5.878)",
    fill: "#37509e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76040",
    "data-name": "Path 76040",
    d: "M56.108,26.486A6.134,6.134,0,1,1,50.4,19.953a6.134,6.134,0,0,1,5.708,6.533",
    transform: "translate(-10.619 9.024)",
    fill: "#aec9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76041",
    "data-name": "Path 76041",
    d: "M49.275,31.951c-.156,0-.314-.005-.469-.016a6.885,6.885,0,0,1,.457-13.754c.156,0,.313.005.469.016a6.885,6.885,0,0,1-.457,13.754Zm-.012-12.27a5.385,5.385,0,0,0-.356,10.757c.122.008.246.012.368.012a5.385,5.385,0,0,0,.356-10.757C49.509,19.686,49.385,19.682,49.263,19.682Z",
    transform: "translate(-10.971 8.531)",
    fill: "#37509e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76042",
    "data-name": "Path 76042",
    d: "M93.021,50.626a.706.706,0,0,0-.077-.374L82.227,29.836a1.715,1.715,0,0,0-2.654-.507L66.024,41.167a2.412,2.412,0,0,1-3.4-.229l-4.364-5a2.414,2.414,0,0,0-3.436-.2L42.675,46.73a.693.693,0,0,0-.228.469l-.434,6.442a.694.694,0,0,0,.647.741L91.816,57.7a.7.7,0,0,0,.74-.645Z",
    transform: "translate(-11.521 13.417)",
    fill: "#aec9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76043",
    "data-name": "Path 76043",
    d: "M92.023,50.14a.75.75,0,0,1-.667-.406L80.727,29.118a.965.965,0,0,0-1.493-.286l-14.074,12.3a2.465,2.465,0,0,1-3.479-.233L56.392,34.84a.967.967,0,0,0-1.375-.081L42.136,46.414A.75.75,0,0,1,41.13,45.3L54.01,33.647a2.467,2.467,0,0,1,3.511.2l5.289,6.054A.965.965,0,0,0,64.172,40L78.246,27.7a2.465,2.465,0,0,1,3.814.728L92.689,49.046a.75.75,0,0,1-.666,1.094Z",
    transform: "translate(-11.707 12.897)",
    fill: "#37509e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadImage);
export default __webpack_public_path__ + "static/media/file_upload_image.be87bd20b446821d00265925f8e33ae7.svg";
export { ForwardRef as ReactComponent };